import { useResponse } from 'contexts/response';
import { useCallback } from 'react';

import { Template } from 'types';

const isBookingTemplate = (json: any): json is Template => typeof json === 'object' && 'bookingDetails' in json;

export const useTemplateApi = () => {
  const { handleError, setSuccess } = useResponse();

  const postTemplate = useCallback(
    async (template: Template): Promise<Template | null> => {
      const url: URL = new URL(
        `/api/booking-templates${!template.id ? '' : `/${template.id}`}`,
        window.location.origin
      );
      const init: RequestInit = {
        method: !template.id ? 'POST' : 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }),
        body: JSON.stringify(template)
      };
      try {
        const response = await fetch(url, init);
        const json = await response.json();

        await Promise.allSettled([response, json]);

        if (response.ok && isBookingTemplate(json)) {
          setSuccess(
            <div className="grid-1">
              <span>{json.name ?? 'TEMPLATE NAME'}</span>
              {json.bookingDetails?.map(({ count, iso }, i) => (
                <span key={i}>
                  {count} x {iso}
                </span>
              ))}
            </div>
          );
          return json;
        }

        switch (response.status) {
          case 500:
            handleError('INTERNAL SERVER ERROR');
            return null;
          case 403:
            handleError('FORBIDDEN');
            return null;
          case 401:
            handleError('UNAUTHORIZED');
            return null;
          default:
            handleError(json.message?.match(/"[^"]+"/)?.[0] ?? response.statusText);
            return null;
        }
      } catch (e) {
        handleError(e);
        return null;
      }
    },
    [handleError, setSuccess]
  );

  return { postTemplate };
};
